import React from 'react'
import './NotConnect.css'
import WalletConnectBtn from '../../Utils/wallet/WalletConnectBtn';
import MagnumIcon from '../../assets/mg-icon.png';
import { useNavigate } from 'react-router-dom';

const NotConnect = ({ noVesting }) => {
    const navigate = useNavigate();
    
    return (
        <div className='not-connect-main-cont'>
            <div className='nc-sub-cont'>
                <img src={MagnumIcon} alt='magnum-icon' />
                {!noVesting ? (
                    <div className='ncs-box-cont'>
                        <h4>Wallet Not Connected!</h4>

                        <p>Please connect your wallet</p>

                        <WalletConnectBtn btnColor={'blue'} />
                    </div>
                ) : (
                    <div className='ncs-box-cont'>
                        <h4>No Vesting Found!</h4>

                        <p>Please vest first</p>

                        <button className='add-vesting-btn' onClick={() => navigate('/vesting/add-vesting')}>Add Vesting</button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default NotConnect;